import {
	AppRouterKeys,
} from '@/shared/model/constants'

import {
	ClubDetailPage,
} from '@/pages/club-detail'
import {
	ClubsPage,
} from '@/pages/clubs'
import {
	ClubsCreatePage,
} from '@/pages/clubs-create'
import {
	GamePage,
} from '@/pages/game'
import {
	HomePage,
} from '@/pages/home'
import {
	NotFoundPage,
} from '@/pages/not-found'
import {
	ProfilePage,
} from '@/pages/profile'
import {
	RoomPage,
} from '@/pages/room'
import {
	RoomCreatePage,
} from '@/pages/room-create'
import {
	RoomsPage,
} from '@/pages/rooms'
import {
	RulesPage,
} from '@/pages/rules'
import {
	RulesDetailPage,
} from '@/pages/rules-detail'

import {
	HomeLayout,
} from '@/modules/home'

import {
	AppRoutes,
} from '../../enums'
import {
	defineRoutes,
} from '../../helpers'

export const baseRoutes = defineRoutes({
	[AppRoutes.HOME]: {
		path:     AppRouterKeys.HOME,
		element:  <HomeLayout />,
		authOnly: true,
		children: [
			{
				path:    AppRouterKeys.HOME,
				element: <HomePage />,
			},
			{
				path:    AppRouterKeys.GAMES,
				element: <RoomsPage />,
			},
			{
				path:    AppRouterKeys.CLUBS,
				element: <ClubsPage />,
			},
			{
				path:    AppRouterKeys.CLUBS_CREATE,
				element: <ClubsCreatePage />,
			},
			{
				path:    AppRouterKeys.CLUB_DETAIL,
				element: <ClubDetailPage />,
			},
			{
				path:    AppRouterKeys.ROOM_CREATE,
				element: <RoomCreatePage />,
			},
			{
				path:    AppRouterKeys.ROOM,
				element: <RoomPage />,
			},
			{
				path:    AppRouterKeys.GAME,
				element: <GamePage />,
			},
			{
				path:    AppRouterKeys.MY_PROFILE,
				element: <ProfilePage />,
			},
			{
				path:    AppRouterKeys.PROFILE,
				element: <ProfilePage />,
			},
			{
				path:    AppRouterKeys.RULES,
				element: <RulesPage />,
			},
			{
				path:    AppRouterKeys.RULES_DETAIL,
				element: <RulesDetailPage />,
			},
			{
				path:    AppRouterKeys.ALL_MATCH,
				element: <NotFoundPage />,
			},
		],
	},
})
